import React from 'react';
import { FlightCheckbox, FlightTextInput } from '@flybits/design-system';
import { PushFormClassPrefix as CLASS_PREFIX } from 'components/ExperienceCanvas/constants';
import { FormData, PushUniversalAction } from 'components/ExperienceCanvas/types';

type ActionLinkFieldControlProps = {
  fieldKey: string;
  fieldMetadata: PushUniversalAction['fields'][number];
  field: FormData[string];
  updateField: (key: string, value: string | null) => void;
  toggleError: (key: string) => void;
  displayValue?: string;
  label?: string;
};

const ActionLinkFieldControl = ({
  fieldKey,
  fieldMetadata,
  field,
  updateField,
  toggleError,
  displayValue,
  label,
}: ActionLinkFieldControlProps) => {
  if (fieldMetadata.isBooleanInput) {
    return (
      <>
        <div className={`${CLASS_PREFIX}__label`}>
          <p className={`${CLASS_PREFIX}__label-primary`}>Overlay</p>
        </div>
        <FlightCheckbox
          className={`${CLASS_PREFIX}__right`}
          checkState={field?.value === 'true' ? 'SELECTED' : 'UNSELECTED'}
          onSelect={() => {
            updateField(fieldKey, field?.value ? null : 'true');
            toggleError(fieldKey);
          }}
        />
      </>
    );
  }

  return (
    <FlightTextInput
      className={`${CLASS_PREFIX}__actionlink__field`}
      width="100%"
      value={displayValue ?? field?.value ?? ''}
      label={label ?? fieldMetadata.name}
      hasError={!!field?.showError}
      errorMessage={field?.error}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateField(fieldKey, e.target.value)}
      onBlur={() => toggleError(fieldKey)}
    />
  );
};

export default ActionLinkFieldControl;
